// src/pages/PrintHouseDelivery/DeliveryDetailModal.tsx
// Chi tiết 1 lần giao vé cho nhà in — mật khẩu bảo vệ file ZIP mặc định ẩn (che bằng dấu chấm),
// chỉ hiện ra sau khi người dùng bấm "Xem mật khẩu" và xác thực lại đúng mật khẩu tài khoản đang
// đăng nhập qua PasswordConfirmModal (xem README.md mục 7).

import React, { useState } from 'react';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { revealPrintHouseDeliveryPasswordApi } from 'helpers/fakebackend_helper';
import PasswordConfirmModal from 'Components/Common/PasswordConfirmModal';
import { PrintHouseDelivery } from './types';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('print_house_delivery');

interface DeliveryDetailModalProps {
  isOpen: boolean;
  delivery: PrintHouseDelivery | null;
  onClose: () => void;
}

const formatNumber = (value?: number | null) => Number(value || 0).toLocaleString('vi-VN');

const DeliveryDetailModal: React.FC<DeliveryDetailModalProps> = ({ isOpen, delivery, onClose }) => {
  const [passwordModalOpen, setPasswordModalOpen] = useState(false);

  if (!delivery) return null;

  const handleVerifyPassword = async (password: string): Promise<string> => {
    const response: any = await revealPrintHouseDeliveryPasswordApi(delivery.id, password);
    const payload = response?.data || response;
    return payload?.password || '';
  };

  return (
    <>
      <Modal isOpen={isOpen} toggle={onClose} centered>
        <ModalHeader className="bg-light p-3" toggle={onClose}>
          {st('chi_tiet_giao_ve_nha_in_title')}
        </ModalHeader>
        <ModalBody>
          <dl className="row mb-0">
            <dt className="col-5 text-muted fw-normal">{st('ma_ky_text')}</dt>
            <dd className="col-7 fw-medium">{delivery.planCode}</dd>

            <dt className="col-5 text-muted fw-normal">{st('tong_so_ve_text')}</dt>
            <dd className="col-7 fw-medium">{formatNumber(delivery.expectedPrintQuantity)}</dd>

            <dt className="col-5 text-muted fw-normal">{st('ten_nha_in_text')}</dt>
            <dd className="col-7 fw-medium">{delivery.printHouseName}</dd>

            <dt className="col-5 text-muted fw-normal">{st('dia_chi_text')}</dt>
            <dd className="col-7 fw-medium">{delivery.address}</dd>

            <dt className="col-5 text-muted fw-normal">{st('nguoi_ghi_nhan_text')}</dt>
            <dd className="col-7 fw-medium">{delivery.createdByName || `#${delivery.createdBy}`}</dd>

            <dt className="col-5 text-muted fw-normal">{st('thoi_gian_text')}</dt>
            <dd className="col-7 fw-medium">{new Date(delivery.createdAt).toLocaleString('vi-VN')}</dd>

            <dt className="col-5 text-muted fw-normal">{st('mat_khau_bao_ve_file_zip_text')}</dt>
            <dd className="col-7">
              <div className="d-flex align-items-center gap-2">
                <span className="fw-medium">••••••••</span>
                <Button color="link" size="sm" className="p-0" onClick={() => setPasswordModalOpen(true)}>
                  {st('xem_mat_khau_button')}
                </Button>
              </div>
            </dd>
          </dl>
        </ModalBody>
        <div className="modal-footer">
          <div className="hstack gap-2 justify-content-end">
            <Button color="light" onClick={onClose}>
              {st('dong_button')}
            </Button>
          </div>
        </div>
      </Modal>

      <PasswordConfirmModal
        isOpen={passwordModalOpen}
        title={st('xac_nhan_mat_khau_tai_khoan_title')}
        revealedLabel={st('mat_khau_bao_ve_file_zip_text')}
        onSubmit={handleVerifyPassword}
        onClose={() => setPasswordModalOpen(false)}
      />
    </>
  );
};

export default DeliveryDetailModal;
